import {
	parseSubscriptionType,
	type SubscriptionType,
} from "./subscriptionType";

export interface AvailableSubscriptionJson {
	type: string;
	name: {
		nb: string;
		en: string;
	};
	description: {
		nb: string;
		en: string;
	};
	pricePerMonth: number | null;
	vatPerMonth: number | null;
}

export interface AvailableSubscription {
	type: SubscriptionType;
	name: {
		nb: string;
		en: string;
	};
	description: {
		nb: string;
		en: string;
	};
	pricePerMonth: number | null;
}

const mapAvailableSubscription = (
	json: AvailableSubscriptionJson,
): AvailableSubscription => {
	return {
		type: parseSubscriptionType(json.type),
		name: {
			nb: json.name.nb,
			en: json.name.en,
		},
		description: {
			nb: json.description.nb,
			en: json.description.en,
		},
		pricePerMonth: json.pricePerMonth,
	};
};

export const getValidAvailableSubscriptionJson = (
	template: "JOULE" | "TICKET" | "CAR_POOL" | "TRAVEL_SUBSCRIPTION" = "JOULE",
): AvailableSubscriptionJson => {
	switch (template) {
		case "JOULE": {
			return {
				type: "JOULE",
				name: {
					nb: "Elsykkel",
					en: "Electric bike",
				},
				description: {
					nb: "Elsykkel via Joule - 999 kr/mnd - Giant explore e+2. Du får en SMS med rabattkode og lenke til Joules nettside (joule.no). Der bestiller du elsykkelen i ønsket størrelse og ramme, og bruker rabattkoden i utsjekksprosessen. Du blir belastet for abonnementet først når sykkelen er utlevert.",
					en: "Electric bike via Joule - 999 NOK/month - Giant explore e+2. You will receive an SMS with a voucher code and link to Joule's website (joule.no), where you order the desired bike size and frame, inputing the voucher code in the checkout process. The subscription will not be charged before the bike is delivered.",
				},
				pricePerMonth: 999.0,
				vatPerMonth: 199.8,
			};
		}
		case "TICKET": {
			return {
				type: "TICKET",
				name: {
					nb: "Bedriftsbillett",
					en: "Subscription ticket",
				},
				description: {
					nb: "En billett som varer helt til den sies opp",
					en: "A ticket that is valid until the subscription is stopped.",
				},
				pricePerMonth: null,
				vatPerMonth: null,
			};
		}
		case "CAR_POOL": {
			return {
				type: "CAR_POOL",
				name: {
					nb: "Leiebil",
					en: "Car rental",
				},
				description: {
					nb: "Leiebil 49 kroner per måned. Hver måned sendes det ut SMS med rabattkode pålydende 200 kr, inkludert to måneder med rollover. Hver måned kan man velge mellom Bilkollektivet, Getaround og Hyre.",
					en: "Car rental 49 NOK per month. An SMS with a voucher valued at 200 NOK is sent each month, including two months of rollover. Each month one may choose between Bilkollektivet, Getaround and Hyre.",
				},
				pricePerMonth: 49.0,
				vatPerMonth: 9.8,
			};
		}
		case "TRAVEL_SUBSCRIPTION":
			return {
				type: "TRAVEL_SUBSCRIPTION",
				name: {
					nb: "Reiseabonnement",
					en: "Travel subscription",
				},
				description: {
					nb: "Reiseabonnement for leiebil og månedsbillett",
					en: "Travel subscription for monthly ticket and car rental",
				},
				pricePerMonth: 0,
				vatPerMonth: 0,
			};
		default: {
			const exhaustiveCheck: never = template;
			throw new Error(`Unhandled switch case: ${exhaustiveCheck}`);
		}
	}
};

export const mapAvailableSubscriptions = (
	json: AvailableSubscriptionJson[],
): AvailableSubscription[] => json.map(mapAvailableSubscription);
